module.exports = __webpack_public_path__ + "static/media/1-11.10032180.mp3";